export const isoDateFormat = function(date?: Date): string | null {
    if (date === null) {
        return null;
    }
    return date.toISOString().slice(0, 10);
};
